import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ReportSummaryModel} from '../reportSummary.model';
import {Injectable} from '@angular/core';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {
    ReportDefinitionSummaryConverter
} from '../../../../report-definition/api/entity/converter/reportDefinitionSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class ReportSummaryConverter extends HttpModelConverter<ReportSummaryModel> {

    constructor(private reportDefinitionSummaryConverter: ReportDefinitionSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): ReportSummaryModel {
        return new ReportSummaryModel();
    }

    protected enrichObject(result: ReportSummaryModel, src: ReportSummaryModel) {
        const dateConverter = new DateConverter();
        const userSummaryConverter = new UserSummaryConverter();
        result.date = dateConverter.convert(src.date);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.updatedAt = dateConverter.convert(src.updatedAt);
        result.createdAt = dateConverter.convert(src.createdAt);
        result.createdBy = userSummaryConverter.convert(src.createdBy);
        result.updatedBy = userSummaryConverter.convert(src.updatedBy);
        result.reportDefinition = this.reportDefinitionSummaryConverter.convert(src.reportDefinition);
        result.status = this.lovValueSummaryConverter.convert(src.status);
    }
}

